/**
 * Limit select for stats tab.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { LENGTH_OPTIONS } from '../../shared/constants';

interface LimitSelectProps {
  value: number;
  onChange: (v: number) => void;
  /** When true, adds "All" option (0) for two-step fetch of totalRows. */
  allowAll?: boolean;
}

const CHEVRON_SVG =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")";

const displayValue = (v: number) => (v === 0 ? 'All' : String(v));

export const LimitSelect: FC<LimitSelectProps> = ({ value, onChange, allowAll }) => (
  <select
    value={value}
    onChange={(e) => onChange(Number(e.target.value))}
    title="Limit (rows)"
    className="h-9 w-fit min-w-0 rounded-md border border-input bg-background bg-no-repeat pr-6 pl-2.5 py-1.5 text-sm text-foreground [background-position:right_0.25rem_center] [background-size:1rem]"
    style={{
      appearance: 'none',
      backgroundImage: CHEVRON_SVG,
      width: `calc(${displayValue(value).length}ch + 2.25rem)`,
    }}
  >
    {allowAll && (
      <option value={0}>
        All
      </option>
    )}
    {LENGTH_OPTIONS.map((n) => (
      <option key={n} value={n}>
        {n}
      </option>
    ))}
  </select>
);
